import { createSlice } from '@reduxjs/toolkit';
import { resetStore, resetStoreNoReload } from './loaderSlice';
const initialState = {
    vendorDetails: {},
    selectedProgramInfo: {},
};
export const vendorSlice = createSlice({
    name: 'vendor',
    initialState,
    reducers: {
        setVendorDetails: (state, action) => {
            state.vendorDetails = action.payload;
        },
        setProgramInfo: (state, action) => {
            state.selectedProgramInfo = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(resetStore, () => initialState);
        builder.addCase(resetStoreNoReload, () => initialState);
    },
});
export const { setVendorDetails, setProgramInfo } = vendorSlice.actions;
export default vendorSlice.reducer;
